import { render, staticRenderFns } from "./EditGeneralView.vue?vue&type=template&id=d020bca4"
import script from "./EditGeneralView.vue?vue&type=script&lang=ts"
export * from "./EditGeneralView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports